export default __webpack_public_path__ + "static/media/hoodie.d3d0ec69.jpeg";